export default "__VITE_PUBLIC_ASSET__81fb67e2__"